import React, { useEffect, useState } from 'react';
import { mediumUsername } from '../data';

const RSS_URL = `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(
  `https://medium.com/feed/@${mediumUsername}`
)}`;

const stripHtml = (html) => {
  if (!html) return '';
  return html.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();
};

const extractThumb = (html) => {
  if (!html) return null;
  const m = html.match(/<img[^>]+src="([^">]+)"/);
  return m ? m[1] : null;
};

const formatDate = (s) => {
  try {
    return new Date(s).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  } catch {
    return s;
  }
};

const MediumFeed = ({ limit }) => {
  const [posts, setPosts] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    fetch(RSS_URL)
      .then((r) => r.json())
      .then((d) => {
        if (d.status === 'ok') {
          setPosts(limit ? d.items.slice(0, limit) : d.items);
          setStatus('ok');
        } else {
          setStatus('error');
        }
      })
      .catch(() => setStatus('error'));
  }, [limit]);

  if (status === 'loading') {
    return <div className="state">Loading latest posts from Medium…</div>;
  }
  if (status === 'error' || posts.length === 0) {
    return (
      <div className="state">
        Couldn't load Medium posts right now.{' '}
        <a href={`https://medium.com/@${mediumUsername}`} target="_blank" rel="noopener noreferrer">
          Read on Medium →
        </a>
      </div>
    );
  }

  return (
    <div className="grid">
      {posts.map((p) => {
        const thumb = p.thumbnail || extractThumb(p.description);
        const excerpt = stripHtml(p.description).slice(0, 180);
        return (
          <article className="card post-card" key={p.guid || p.link}>
            <div
              className="post-thumb"
              style={thumb ? { backgroundImage: `url(${thumb})` } : undefined}
            />
            <div className="post-body">
              <div className="post-meta">
                {formatDate(p.pubDate)}
                {p.categories && p.categories.length > 0 && ` · ${p.categories.slice(0, 2).join(', ')}`}
              </div>
              <h3>
                <a href={p.link} target="_blank" rel="noopener noreferrer">
                  {p.title}
                </a>
              </h3>
              <p className="post-excerpt">{excerpt}…</p>
            </div>
          </article>
        );
      })}
    </div>
  );
};

export default MediumFeed;
